import { Component } from 'react'
import {
  TextField, IconButton, Tooltip, Box, Typography, Button, ButtonGroup, Menu,
  MenuItem, Stack, Dialog, DialogContent, DialogActions, FormControl, Select, InputLabel,
  Drawer, Autocomplete
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import {
  AppointmentCard, CommonGridToolBarWithFilterTextCustom, ReasonPopup,
  PovEditPopup, NewCommonPatientDetails
} from '../../../../Components/Common Components/CommonComponents';
import { DataGrid, gridNumberComparator } from '@mui/x-data-grid';
import { Colors } from '../../../../Styles/Colors';
import { withTranslation } from 'react-i18next';
import NextAppointments from '../../../FrontOffice/OutPatients/NextAppointments';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { clearCachevalue, getCachevalue, localGetItem, localSetItem, setCachevalue }
  from '../../../../Utility/Services/CacheProviderService';
import moment from 'moment/moment';
import { appointment_Status_opt, showDilationList } from '../../../../Utility/Constants';
import { AmountFormat, formatToCustomDateTime, calculateWaitingTime, formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';
import PaymentsIcon from '@mui/icons-material/Payments';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ReportIcon from '@mui/icons-material/Report';

const DilationList = ["Tropicamide Plus", "Homide", "Cylopentolate"]
class JmoDoctorHome extends Component {
  constructor(props) {
    super(props)
    this.state = {
      datePicker: new Date(),
      AptTblData: [],
      patientCount: {},
      totalAppointment: {},
      anchorEl: null,
      selectedRow: null,
      selectedOption: "",
      isSelected: false,
      selectedID: "",
      selectedCard: '',
      SelectedPatientDetails: {},
      waitingCmts: false,
      deletedPopup: false,
      cancelAppointment: false,
      page: 0,
      pageSize: 10,
      waitCmtText: '',
      isErrorMsg: false,
      isErrorMsgText: '',
      FilterOpen: false,
      SelectedPatientTags: [],      
      successMsg: false,
      successMsgText: '',
      timeDiff: null,
      SelectedDoctorID: "",
      DoctorsList: [],
      DatePickerOpen: false,
      tokenNum: '',
      barcodeHeader: false,
      loading: false,
      SelectedDoctorClinic: '',
      isOPT: false,
      isOthometry: false,
      unlockDate: "",
      timer: '',
      currentTime: new Date(),
      povText: {},
      ispovPopOpen: false,
      onChangePov: false,
      isDocOnEmergency: false,
      slctMenuOption: "",
      isRemarks: false,
      remarkText: '',
      isRemarkId: null,
    }
    this.TokenScreen = null;
    this.EmergencySocket = null;
    this.PaitentCall = null;
    this.DocCallPatient = null;
  }

  componentDidMount() {
    clearCachevalue("DoctorPatientData")
    clearCachevalue("CurrentDoctorPatientData")
    clearCachevalue('updatePatient')
    var DoctorClinicId = localGetItem('SelectedDoctorClinicId')
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    var UserData = myUser
    let selectedDate = JSON.parse(getCachevalue('SelectedDate'))
    this.getPatientTagList()
    if (UserData?.is_qms_enabled) {
      this.WebSocketConnection(UserData)
    }
    if (DoctorClinicId !== this.state.SelectedDoctorClinic && DoctorClinicId) {
      this.setState({
        SelectedDoctorClinic: DoctorClinicId, isOPT: UserData.service_type === "OPT" ? true : false, isOthometry: UserData.service_type === "OPTOMETRY", datePicker: selectedDate ? selectedDate : new Date()
      }, () => {
        clearCachevalue('SelectedDate')
        setTimeout(() => {
          this.getPatientDetails()
          this.getDoctorsList()
          if (UserData?.module_name === "Doctor") {
            this.updateAutolock()
          }
        }, 1000)
      })
    }
    localSetItem('DoctorAppointmentDate', this.state.datePicker)
    if ((UserData.service_type === "OPTOMETRY") || (UserData.service_type === "OPT")) {
      this.intervalId = setInterval(() => {
        this.setState({ currentTime: formatToCustomDateTime(new Date()) });
      }, 1000);
    }
    // UserData.service_type !== "OPTOMETRY" && 
    if(DoctorClinicId){
      this.getDoctorCustomConfig()
    }
  }


  componentDidUpdate(prevProps) {
    let DoctorID = JSON.parse(localGetItem("SelectedDoctorID"))
    var DoctorClinicId = getCachevalue('SelectedDoctorClinic')
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    let selectedDate = JSON.parse(getCachevalue('SelectedDate'))

    var UserData = myUser
    if (prevProps.history?.location?.state?.NewAppointmentCreated) {
      this.setState({ datePicker: selectedDate ? selectedDate : new Date() },() =>  clearCachevalue('SelectedDate'))
      this.successMsgFunc(prevProps.history?.location?.state?.NewMessage)
      this.props.history.push({ state: { NewAppointmentCreated: false } })
        this.getPatientDetails()
    }
    if (DoctorID !== this.state.SelectedDoctorID && DoctorID) {
      this.setState({ SelectedDoctorID: DoctorID, datePicker: selectedDate ? selectedDate : new Date() }, () => {
        clearCachevalue('SelectedDate')
        setTimeout(() => {
          this.getPatientDetails()
        }, 1500)
      })
    }
    if (DoctorClinicId !== this.state.SelectedDoctorClinic && DoctorClinicId) {
      this.setState({ SelectedDoctorClinic: DoctorClinicId, isOPT: UserData.service_type === "OPT" ? true : false, isOthometry: UserData.service_type === "OPTOMETRY", datePicker: selectedDate ? selectedDate : new Date() }, () => {
        clearCachevalue('SelectedDate')
        setTimeout(() => {
          this.getPatientDetails()
          this.getDoctorsList()
          if (UserData?.module_name === "Doctor") {
            this.updateAutolock()
          }
        }, 1000)
      })
    }
    if ((this.props.changeDate !== this.state.unlockDate) && this.state.SelectedDoctorClinic) {
      this.setState({
        unlockDate: this.props.changeDate,
        datePicker: this.props.changeDate,
      }, () => {
        clearCachevalue('SelectedDate')
        this.getchangePatientAppointmentDate()
      })
    }
    if (prevProps?.CallPatientTrigger !== this.props?.CallPatientTrigger && this.props?.CallPatientTrigger) {
      this.setState({ datePicker: selectedDate ? selectedDate : new Date() },() =>  clearCachevalue('SelectedDate'))
      this.getPatientDetails()
      this.props.ClearCalledTrigger()
    }
  }

  componentWillUnmount = () => {
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    if (myUser?.is_qms_enabled) {
      if (this.TokenScreen) {
        this.TokenScreen.close()
      }
      if (this.EmergencySocket) {
        this.EmergencySocket.close()
      }
      if (this.PaitentCall) {
        this.PaitentCall.close()
      }
      if (this.DocCallPatient) {
        this.DocCallPatient.close()
      }
    }
  }

  WebSocketConnection = (userData) => {
    let emergencyChannel = userData?.emergency_channel_name
    let docCallChannel = userData?.doctor_call_channel_name
    let tokenScreen = userData?.token_screen_channel_name
    let org_id = JSON.parse(localGetItem("org_id"))

    if (this.EmergencySocket === null) {
      this.EmergencySocket = new WebSocket(`${Serviceurls.WEB_SOCKET_DOMAIN}${Serviceurls.DOC_EMERGENCY_WEBSOCKET}${emergencyChannel}/?org_id=${org_id}`);
    }
    if (this.DocCallPatient === null) {
      this.DocCallPatient = new WebSocket(`${Serviceurls.WEB_SOCKET_DOMAIN}${Serviceurls.DOC_PATIENTCALL_WEBSOCKET}${docCallChannel}/?org_id=${org_id}`);
    }
    if (this.TokenScreen === null && tokenScreen) {
      this.TokenScreen = new WebSocket(`${Serviceurls.WEB_SOCKET_DOMAIN}${Serviceurls.TOKENSCREEN_WEBSOCKET}${tokenScreen}/?org_id=${org_id}`);
    }

    const socketMapping = {
      EmergencySocket: this.EmergencySocket,
      PaitentCall: this.PaitentCall,
      DocCallPatient: this.DocCallPatient,
      TokenScreen: this.TokenScreen,
    };

    Object.entries(socketMapping)?.forEach(([name, socket]) => {
      if (socket) {
        socket.onopen = () => {
          console.log(`${name} WebSocket connected`);
        }
        socket.onclose = () => {
          console.log(`${name} WebSocket disconnected`);
          name = null
        }
        socket.onerror = (error) => {
          console.log(`${name} WebSocket Error`, error);
          socket.close()
        }
        socket.onmessage = (e) => {
          const data = JSON.parse(e.data);
          console.log(`${name} WebSocket Message`, data);
          if (name === "PaitentCall" && data) {
            // this.getPatientDetails()
            // if (data?.status === "Cancelled" && this.TokenScreen) {
            //   this.TokenScreen.send(JSON.stringify({
            //     message_id: data?.message_id,
            //     action: "remove_message"
            //   }))
            // }
            // enqueueSnackbar(data?.message)
          }
        }
      }
    })
  }

  getPatientTagList(){
    try {
      let clinicID = localGetItem('clinicId')
      RestAPIService.getAll(Serviceurls.FO_CONFIG_OPPATIENTTAG + `?clinic_id=${clinicID}`).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              PatientTagList: response.data.data
            })
          }
          else {
            this.errorMsgFunc(response.data.message)
          }
        }).catch((e) => {
          this.errorMsgFunc(e.message)
        })
    }
    catch (e) {
      this.errorMsgFunc(e.message)
    }
  }

  getDoctorCustomConfig = () => {
    try {
      let DoctorClinicId = localGetItem('JMODoctor')
      RestAPIService.getAll(`${Serviceurls.DOC_OPT_CONFIG}?doctor_id=${DoctorClinicId}`)
        .then((response) => {
          if (response.data.status === 'success') {
            let status = response.data.data.app_landing_sts === 'All' ? '' : response.data.data.app_landing_sts
            this.setState({ selectedCard: response.data.data.app_landing_sts ? status : '' })
          }
        }).catch(error => {
          if (error?.response?.data?.message) {
            this.errorMsgFunc(error?.response?.data?.message)
          } else {
            this.errorMsgFunc(error?.message)
          }
        })
    } catch (error) {
      this.errorMsgFunc(error?.message)
    }
  }

  closeFilter = () => {
    this.setState({ FilterOpen: false })
  }

  ClearFilterData = () => {
    this.setState({
      SelectedPatientTags: []
    }, () => {
      this.getPatientDetails()
      this.setState({
        FilterOpen: false
      })
    })
  }

  renderFilterScreen = () => {
    const { t } = this.props
    return (
      <Box component={"div"} className='eMed_rts_filter_container'>
        <Box component={"div"} className='eMed_filter_Top'>
          <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
          <Button
                style={{paddingLeft : '0'}}
                onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn' emed_tid='opHome_filter_close_btn'>
            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
          </Button>
        </Box>
        <Box className="eMed_Filter_Header">
          <Typography marginLeft={"1vw"}>{t("Patient Filter")}</Typography>
        </Box>
        <Box className='eMed_rts_middle' display={'flex'} flexDirection={'column'} justifyContent={'space-between'}>
          <Box>
            {localGetItem('show_patient_tag_filter') === 'true' ? 
            <Box className='eMed_rts_dropdown'>
              <Autocomplete
                  multiple
                  limitTags={1}
                  size='small'
                  options={this.state.PatientTagList}
                  getOptionLabel={(option) => (option?.patient_tag_name)}
                  value={this.state.SelectedPatientTags}
                  onChange={(event, newValue) => {
                      this.setState({ SelectedPatientTags: newValue })
                  }}
                  renderOption={(props, option) => (
                      <li {...props} key={option?.patient_tag_name}>
                          {option?.patient_tag_name}
                      </li>
                  )}
                  renderInput={(params) => (
                      <TextField
                          {...params}
                          label={t('Select Patient Tag')}
                          emed_tid = {"doctorName_TestID"}
                          sx={{ width: "21vw"}}
                      />
                  )}
              />
            </Box> : null}
          </Box>
          <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
            <Button variant='outlined' size="small" emed_tid='opHome_filter_clear_btn'
              onClick={() => { this.ClearFilterData() }}
              id="eMed_Config_btn">{t("Clear")}</Button>
            <Button variant='contained' size="small" emed_tid='opHome_filter_search_btn' disabled={this.state.disableBtn}
              onClick={() => {
                this.getPatientDetails()
                this.setState({
                  FilterOpen: false
                })
              }}
              id="eMed_Config_btn">{t("Search")}</Button>
          </Stack>
        </Box>
      </Box>
    )
  }

  errorMsgFunc = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMsgFunc = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  getchangePatientAppointmentDate = () => {
    try {
      let states = this.state
      let clinicId = localGetItem('SelectedDoctorClinicId') !== null ? (localGetItem('SelectedDoctorClinicId') ? localGetItem('SelectedDoctorClinicId') : getCachevalue('SelectedDoctorClinic')) : this.state.SelectedDoctorClinic
      let ApiUrl = ""
      let UserData = JSON.parse(localGetItem("loggedInUserInfo"))

      if (UserData?.service_type === "OPTOMETRY") {
        ApiUrl = Serviceurls.DOC_OPTHOMETRY_APPOINTMENT_LIST + "?appointment_date=" + states?.unlockDate + "&appointment_status=" + this.state.selectedCard + '&doctor_id=' + (this.state.SelectedDoctorClinic === 'all' ? "" : this.state.SelectedDoctorClinic)
      } else {
        ApiUrl = Serviceurls.DOC_APPOINTMENT_LIST + "?appointment_date=" + states?.unlockDate + "&appointment_status=" + this.state.selectedCard + '&clinic_id=' + this.state.SelectedDoctorClinic
      }
      this.setState({ loading: true })
      RestAPIService.getAll(ApiUrl)
        .then(response => {
          if (response.data.status === "success") {
            this.setState({
              AptTblData: response.data.data ? response.data.data : [],
              patientCount: response.data.patient_arrived_count ? response.data.patient_arrived_count : {}
            }, () => { this.getPatientAppointmentStatusCount() });
          }
        }).catch(e => {
          if (e?.response?.data?.status === "fail") {
            this.errorMsgFunc(e.response.data.message)
          } else {
            this.errorMsgFunc(e.message)
          }
          this.setState({ loading: false })
        })
    } catch (e) {
      this.setState({ loading: false })
      this.errorMsgFunc(e.message)
    }
  }

  getPatientDetails = () => {
    try {
      let states = this.state
      let StateDate = new Date(states.datePicker)
      let date = states.datePicker ? DateTime.fromJSDate(StateDate).toFormat('yyyy-MM-dd') : null
      setCachevalue(date, 'OpAppDate')
      setCachevalue(states.selectedCard, 'OPStatus')
      let docID = localGetItem('JMODoctor')
      let clinicID = localGetItem('clinicId')
      let patientTagFilter = []
      this.state.SelectedPatientTags.forEach(element => patientTagFilter.push(element.patient_tag_name))
      if (date === 'Invalid DateTime') {
      } else {
        this.setState({ loading: true })
        let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
        let ApiUrl = ""
          ApiUrl = Serviceurls.JMO_APPOINTMENT_GET + "?appointment_date=" + date + "&appointment_status=" + this.state.selectedCard + '&doctor_id=' + docID + '&clinic_id=' + clinicID  + '&patient_tag_name='+ patientTagFilter
        RestAPIService.getAll(ApiUrl)
          .then(response => {
            if (response.data.status === "success") {
              this.setState({
                AptTblData: response.data.data ? response.data.data : [],
                patientCount: response.data.patient_arrived_count ? response.data.patient_arrived_count : {},
                isDocOnEmergency: response.data?.out_for_emergency ? response.data?.out_for_emergency : false,
              }, () => {
                this.state.AptTblData.forEach((element) => {
                  element.patientDetails = `${element.patient_name} ${element.patient_account_number} ${element.patient_mobile_number}`
                })
                let waitingPatientData = JSON.parse(getCachevalue('WaitingPatientData'))
                let waitingTime = JSON.parse(getCachevalue('waitingTime'))
                if (waitingPatientData?.waiting_timer === null) {
                  let filterPatientData = this.state.AptTblData?.find(item => item?.patient_id === waitingPatientData?.patient_id)
                  // if (filterPatientData?.waiting_timer === null && filterPatientData?.appointment_status === 'With Doctor') {
                  //   this.postPatientStatus('', filterPatientData?.appointment_id, filterPatientData?.waiting_comment, waitingTime, null, true)
                  // } else if (filterPatientData?.waiting_timer === null && filterPatientData?.appointment_status === 'Completed') {
                  //   this.postPatientStatus('Completed', filterPatientData?.appointment_id, filterPatientData?.waiting_comment, waitingTime, null, true)
                  // }
                }
                setTimeout(() => {
                  clearCachevalue('WaitingPatientData')
                  clearCachevalue('waitingTime')
                }, 1000)
                this.getPatientAppointmentStatusCount()
              }
              );
            }
          }).catch(e => {
            if (e?.response?.data?.status === "fail") {
              this.setState({ loading: false })
              this.errorMsgFunc(e.response.data.message)
            } else {
              this.setState({ loading: false })
              this.errorMsgFunc(e.message)
            }
          })
      }
    } catch (e) {
      this.setState({ loading: false })
      this.errorMsgFunc(e.message)
    }
  }

  updateAutolock = () => {
    try {
      let DoctorClinicId = localGetItem('SelectedDoctorClinicId')
      RestAPIService.getAllTwo(Serviceurls.DOC_NOTES_AUTO_LOCK + `?clinic_id=${DoctorClinicId}`)
        .then(response => {
          if (response.data.status === "success") {

          }
        })
        .catch(error => {
          if (error?.response?.data?.status === "fail") {
            this.errorMsgFunc(error.response.data.message)
          }
        });
    } catch (e) {
      this.errorMsgFunc(e.message);
    }
  }

  getPatientAppointmentStatusCount = () => {
    try {
      let states = this.state
      let StateDate = new Date(states.datePicker)
      let date = states.datePicker ? DateTime.fromJSDate(StateDate).toFormat('yyyy-MM-dd') : null
      let DoctorClinicId = localGetItem('JMODoctor')
      let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
      let patientTagFilter = []
      this.state.SelectedPatientTags.forEach(element => patientTagFilter.push(element.patient_tag_name))
      let ApiUrl = ""
      let clinicID = localGetItem('clinicId')
      
        ApiUrl = Serviceurls.DOC_APPOINTMENT_STATUS + `?doctor_id=${DoctorClinicId}&clinic_id=${clinicID}&appointment_date=${date}&patient_tag_name=${patientTagFilter}`
      RestAPIService.getAll(ApiUrl)
        .then((response => {
          if (response?.data?.status === 'success') {
            this.setState({
              totalAppointment: response.data.data ? response.data.data : {},
              loading: false
            })
          }
        })).catch(e => {
          if (e?.response?.data?.status === "fail") {
            this.setState({ loading: false })
            this.errorMsgFunc(e.response.data.message)
          } else {
            this.setState({ loading: false })
            this.errorMsgFunc(e.message)
          }
        })
    } catch (error) {
      this.errorMsgFunc(error.message)
    }
  }


  postPatientStatus = (status, id, comments, time, waitTime, forWaitingTimer, rowData) => {
    try {
      var states = this.state
      var data = {
        "appointment_id": id,
        "appointment_status": status,
        "for_waiting_time": forWaitingTimer ? true : false,
        "clinic_id": this.state.SelectedDoctorClinic,
        ...(status === "Arrived" && {
          appointment_time: DateTime.fromJSDate(new Date()).toLocaleString(DateTime.TIME_24_WITH_SECONDS)
        })
      }
      if (rowData && !waitTime) {
        const waiting_time = calculateWaitingTime(rowData);
        data["waiting_timer"] = waiting_time
      } else {
        data["waiting_timer"] = waitTime ? waitTime : null
      }
      if (states.waitingCmts) {
        data['waiting_comment'] = comments
      }
      if (states.cancelAppointment) {
        data['cancel_reason'] = comments.replace(/\s+/g, ' ').trim()
        data['is_transfered'] = false
        data['transfer_doctor_id'] = null
      }
      RestAPIService.create(data, Serviceurls.DOC_APPOINTMENT_STATUS_UPDATE)
        .then(response => {
          if (response.data.status == "success") {

            if ((status === "With Doctor" || status === 'Optometry Completed') && this.state.isOthometry) {
              let AptData = this.state.AptTblData.find((list) => (list?.appointment_id === id))
              let FirstDilationDetails = AptData?.dilation_details ? AptData?.dilation_details[0] : {}
              let SecondDilationDetails = AptData?.dilation_details ? AptData?.dilation_details[1] : null
              if (FirstDilationDetails?.start_time && !FirstDilationDetails?.end_time) {
                this.UpdateDilationTime(id, false, true, 0)
              } else if (SecondDilationDetails?.start_time && !SecondDilationDetails.end_time) {
                this.UpdateDilationTime(id, false, true, 1)
              } else {
                this.getPatientDetails()
                this.setState({
                  waitCmtText: ''
                })
              }
            } else
              this.getPatientDetails()
            this.setState({
              waitCmtText: ''
            })
          }
        }).catch(e => {
          if (e?.response?.data?.status === "fail") {
            this.errorMsgFunc(e.response.data.message)
          } else {
            this.errorMsgFunc(e.message)
          }
        })
    } catch (e) {
      this.errorMsgFunc(e.message)
    }
  }

  UpdateDilationTime = (id, StartTime = false, EndTime = false, index , selectDilation) => {
    try {
      let DilationObj = this.state.AptTblData.find((list) => (list?.appointment_id === id)) ? this.state.AptTblData.find((list) => (list?.appointment_id === id))?.dilation_details : null
      let DilationValue = DilationObj ? DilationObj[index] ? DilationObj[index]?.dilation : null : null
      if (DilationValue) {
        var data = {
          "appointment_id": id,
          "dilation": DilationValue,
          "set_start_time": StartTime,
          "set_end_time": EndTime
        }
        if (selectDilation) {
          data = {
            "appointment_id": id,
            "dilation": DilationValue,
            "dilation_type_change": true,
            "set_start_time": StartTime,
            "set_end_time": EndTime
          }
        }
        RestAPIService.create(data, Serviceurls.DOC_DILATION_TIMER_UPDATE)
          .then(response => {
            if (response.data.status == "success") {
              this.getPatientDetails()
            }
          }).catch(e => {
            if (e?.response?.data?.status === "fail") {
              this.errorMsgFunc(e.response.data.message)
            } else {
              this.errorMsgFunc(e.message)
            }
          })
      } else {
        this.errorMsgFunc("Select the Dilation Type")
      }
    } catch (e) {
      this.errorMsgFunc(e.message)
    }
  }

  getDoctorsList() {
    try {
      let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
      RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME + `?clinic_id=${UserData?.service_type === "OPTOMETRY" ? UserData?.clinic_id : this.state.SelectedDoctorClinic}`).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              DoctorsList: response.data.data.filter((item) => (item.specialization_active === true))
            })
          }
          else {
            this.errorMsgFunc(response.data.message)
          }
        }).catch((e) => {
          this.errorMsgFunc(e.message)
        })
    }
    catch (e) {
      this.errorMsgFunc(e.message)
    }
  }

  getPatientPrescriptionPrint = () => {
    let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
    try {
      let APIUrl = ""
      if (this.state.isOPT || UserData?.service_type === "OPTOMETRY") {
        APIUrl = Serviceurls.OPT_PRESCRIPTION_PRINT + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&doctor_id=" + this.state.SelectedPatientDetails?.doctor_id + "&clinic_id=" + this.state.SelectedDoctorClinic + "&language=english"
      }
      else {
        APIUrl = Serviceurls.PRINT_PRESCRIPTION + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&doctor_id=" + this.state.SelectedPatientDetails?.doctor_id + "&clinic_id=" + this.state.SelectedDoctorClinic + "&export_type=pdf"
      }
      this.setState({ selectedOption: "" })
      RestAPIService.getAllTwo(APIUrl).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "", slctMenuOption: "" })
        }).catch((error) => {
          this.errorMsgFunc(error.response?.data?.message);
          this.setState({ selectedOption: "", slctMenuOption: "" })
        })
    } catch (error) {
      this.errorMsgFunc(error.message)
      this.setState({ selectedOption: "", slctMenuOption: "" })
    }
  }

  getPatientDoctorNotesPrint = () => {
    try {
      var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
      let APIUrl = ""
      if (this.state.isOPT || myUser?.service_type === 'OPTOMETRY') {
        APIUrl = Serviceurls.OPT_PATIENT_DOCTOR_NOTES_PRINT + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&patient_id=" + this.state.SelectedPatientDetails?.patient_id  + "&doctor_notes=all" + "&doctor_id=" + this.state.SelectedPatientDetails?.doctor_id + "&clinic_id=" + this.state.SelectedDoctorClinic
      } else {
        APIUrl = Serviceurls.DOCTOR_NOTES_PRINT + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&doctor_notes=all" + "&doctor_id=" + this.state.SelectedPatientDetails?.doctor_id + "&clinic_id=" + this.state.SelectedDoctorClinic
      }
      this.setState({ selectedOption: "" })
      RestAPIService.getAllPrint(APIUrl).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "", slctMenuOption: "" })
        }).catch((error) => {
          this.errorMsgFunc(error.response?.data?.message);
          this.setState({ selectedOption: "", slctMenuOption: "" })
        })
    } catch (error) {
      this.errorMsgFunc(error.message)
      this.setState({ selectedOption: "", slctMenuOption: "" })
    }
  }

  getPatientOpCardPrint = (barcodeHeader) => {
    try {
      let Url = ""
      let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
      if (UserData?.service_type === "OPTOMETRY") {
        Url = Serviceurls.OP_CARD_PRINT + "?patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&clinic_id=" + UserData?.clinic_id
      }
      if (barcodeHeader) {
        Url = Serviceurls.OP_CARD_PRINT + "?patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&clinic_id=" + this.state.SelectedDoctorClinic + "&header=false"
      } else {
        Url = Serviceurls.OP_CARD_PRINT + "?patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&clinic_id=" + this.state.SelectedDoctorClinic
      }
      RestAPIService.getAll(Url).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "", slctMenuOption: "" })
        }).catch((error) => {
          this.errorMsgFunc(error.response?.data?.message);
          this.setState({ selectedOption: "", slctMenuOption: "" })
        })
    } catch (error) {
      this.setState({ selectedOption: "", slctMenuOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  getPatientOpBillDetailPrint = () => {
    try {
      RestAPIService.getAll(Serviceurls.OP_DETAILED_BILL_PRINT + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&clinic_id=" + this.state.SelectedDoctorClinic).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "", slctMenuOption: "" })
        }).catch((error) => {
          if (error.response?.data?.message) {
            this.errorMsgFunc(error.response?.data?.message);
          } else {
            this.errorMsgFunc(error.message);
          }
          this.setState({ selectedOption: "", slctMenuOption: "" })
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
      this.setState({ selectedOption: "", slctMenuOption: "" })
    }
  }
  getPatientPresTemplate = () => {
    let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
    try {
      let token = this.state.tokenNum ? this.state.tokenNum : null
      this.setState({ selectedOption: "" });
      RestAPIService.getAllPrint(Serviceurls.OP_PRES_TEMPLATE + "?patient_id=" + this.state.SelectedPatientDetails?.patient_id +
        "&doctor_id=" + this.state.SelectedPatientDetails?.doctor_id + "&appointment_id=" + this.state.SelectedPatientDetails?.appointment_id +
        "&token_number=" + token + "&clinic_id=" + (UserData?.service_type === "OPTOMETRY" ? UserData?.clinic_id : this.state.SelectedDoctorClinic))
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "", slctMenuOption: "" })
        }).catch((error) => {
          this.errorMsgFunc(error.response?.data?.message);
          this.setState({ selectedOption: "", slctMenuOption: "" })
        })
    } catch (error) {
      this.errorMsgFunc(error.message)
      this.setState({ selectedOption: "" })
    }
  }
  getCommonBarCodePrint = () => {
    let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
    try {
      RestAPIService.getAll(Serviceurls.COMMON_BARCODE_PRINT + "?patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&clinic_id=" + (UserData?.service_type === "OPTOMETRY" ? UserData?.clinic_id : this.state.SelectedDoctorClinic)).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "", slctMenuOption: "" })
        }).catch((error) => {
          if (error.response?.data?.message) {
            this.errorMsgFunc(error.response?.data?.message);
          } else {
            this.errorMsgFunc(error.message);
          }
          this.setState({ selectedOption: "", slctMenuOption: "" })
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  getMedicalRecordPrint = () => {
    let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
    try {
      RestAPIService.GetWithoutReplica(Serviceurls.Medical_Record_PRINT_CONFIG_PREVIEW + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&clinic_id=" + (UserData?.service_type === "OPTOMETRY" ? UserData?.clinic_id : this.state.SelectedDoctorClinic)).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "", slctMenuOption: "" })
        }).catch((error) => {
          if (error.response?.data?.message) {
            this.errorMsgFunc(error.response?.data?.message);
          } else {
            this.errorMsgFunc(error.message);
          }
          this.setState({ selectedOption: "", slctMenuOption: "" })
        })
    } catch (error) {
      this.setState({ selectedOption: "", slctMenuOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  renderOPHeader = () => {
    const { t } = this.props
    let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
    return (
      <div className='eMed_OP_AptHead'>
        <p>{t('Doctor Appointments')}</p>
        <div className='eMed_Header_OP_home_div'>
          {UserData?.service_type === "OPTOMETRY" ? null :
            UserData?.is_qms_enabled ?
              <Button
                color='error'
                variant='contained'
                startIcon={this.state.isDocOnEmergency ? <NotificationsOffIcon /> : <NotificationsActiveIcon />}
                sx={{ marginRight: "1vw", width: "12vw" }}
                size='small'
                emed_tid='doc_module_emergency_btn'
                disabled={this.state.disableBtn}
                onClick={() => { this.setState({ isDocOnEmergency: !this.state.isDocOnEmergency, disableBtn: true }, () => { this.onEmergency() }) }}>
                {this.state.isDocOnEmergency ? `Stop Emergency` : `Emergency`}
              </Button> : null}

          {localGetItem('show_patient_tag_filter') === 'true' ? 
          <Tooltip title="Filter" placement='top' arrow>
            <Button className='eMed_usrconf_btn' emed_tid='opHome_filter_btn' onClick={() => { this.setState({ FilterOpen: true }) }}>
              <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
            </Button>
          </Tooltip> : null}

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              open={this.state.DatePickerOpen}
              onOpen={() => { this.setState({ DatePickerOpen: true }) }}
              onClose={() => { this.setState({ DatePickerOpen: false }) }}
              value={this.state.datePicker}
              name={"datePicker"}
              inputFormat='DD-MM-YYYY'
              views={["year", "month", "day"]}
              onChange={
                (newDate) => {
                  this.setState({
                    datePicker: newDate,
                    // selectedCard: ''
                  }, () => {
                    this.getPatientDetails()
                    setCachevalue(JSON.stringify(this.state.datePicker), 'SelectedDate')
                    localSetItem('DoctorAppointmentDate', this.state.datePicker)
                  });
                }}
              renderInput={(params) => <TextField onKeyDown={(e) => e.preventDefault()} style={{ width: '10vw' }} size='small' {...params} onClick={() => { this.setState({ DatePickerOpen: true }) }} />}
            />
          </LocalizationProvider>
        </div>
      </div>
    )
  }

  renderPatientType = () => {
    const { t } = this.props
    let { history } = this.props;
    var states = this.state
    // Opt Doc filter
    let is_opt = false
    let is_selectopt = false
    var is_optdoc = states.DoctorsList.find((item) => {
      if ((item.specialization_name === Serviceurls.ROLE_OPT || item.specialization_name === Serviceurls.ROLE_OPTOMETRY) && this.state.isOPT) {
        is_opt = true
      } else {
        is_opt = false
      }
      return is_opt
    }
    )
    // select Opt Doc filter
    var is_optselect = getCachevalue('SelectedDoctorID')
    var is_optDocselect = states.DoctorsList.filter((item) => (item.doctor_id === +is_optselect))
    var is_selectoptdoc = is_optDocselect.find((item) => {
      if ((item.specialization_name === Serviceurls.ROLE_OPT || item.specialization_name === Serviceurls.ROLE_OPTOMETRY) && this.state.isOPT) {
        is_selectopt = true
      } else {
        is_selectopt = false
        is_optdoc = false
      }
      return is_selectopt, is_optdoc
    }
    )
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    var UserData = myUser
    let appointmentStatus = JSON.parse(localGetItem('appointment_status')) ? JSON.parse(localGetItem('appointment_status')) :
      JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status ? JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status !== null ? JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status :
        appointment_Status_opt : appointment_Status_opt
    return (
      <div className='eMed_OP_AddPatient'>
        <div className='eMed_OP_PatientType_CreateBtn' >
          <div className='eMed_OP_PatientTypeCont' style={{ marginLeft: UserData?.service_type !== "OPTOMETRY" ? 0 : "1vw" }}>
            <p className='eMed_OP_TypeNew'><img className='eMed_OP_Patient_Iconcircle' src={ImagePaths.NewPatient.default} alt={'New Patient'} /> {t('NewPatients') + ' (' + (states.patientCount.new_patient ? states.patientCount.new_patient : '0') + ')'}</p>
            <p className='eMed_OP_TypeEstablished'><img className='eMed_OP_Patient_Iconcircle' src={ImagePaths.EstablishedPatient.default} alt={'Review Patient'} /> {t('ReviewPatients') + ' (' + (states.patientCount.review_patient ? states.patientCount.review_patient : '0') + ')'}</p>
            <p className='eMed_OP_TypeEstablished'><img className='eMed_OP_Patient_Iconcircle' src={ImagePaths.ReviewPatient.default} alt={'Old Patient'} /> {t('Old Patients') + ' (' + (states.patientCount.old_patient ? states.patientCount.old_patient : '0') + ')'}</p>
          </div>
        </div>
        <div>
          <div className='eMed_OP_Apt_Cards' style={{ width: "80dvw", placeContent: "end" }}>
            <AppointmentCard onClick={() => { this.setState({ selectedCard: '' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.BookedPatientFill.default} count={states.totalAppointment.total} label={t("All")} color={"#616161"} isSelectedCard={states.selectedCard === "" ? true : false} />
            <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Booked' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.BookedPatientFill.default} count={states.totalAppointment.booked} label={t("Booked")} color={"#616161"} isSelectedCard={states.selectedCard === "Booked" ? true : false} />
            <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Ip Appointment' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.BookedPatientFill.default} count={states.totalAppointment.ip_appointment} label={t("IP Appointment")} color={"#5fbe39"} isSelectedCard={states.selectedCard === "Ip Appointment" ? true : false} />
            <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Arrived' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.StatusArrivedFill.default} count={states.totalAppointment.arrived} label={t("Arrived")} color={"#0461B7"} isSelectedCard={states.selectedCard === "Arrived" ? true : false} />
            {this.state.totalAppointment?.with_nurse > 0 && !appointmentStatus[1]?.is_checked ?
              <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With Nurse' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.StatusNurseFill.default} count={states.totalAppointment.with_nurse} label={t("WithNurse")} color={"#AF2591"} isSelectedCard={states.selectedCard === "With Nurse" ? true : false} /> :
              appointmentStatus[1]?.is_checked ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With Nurse' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.StatusNurseFill.default} count={states.totalAppointment.with_nurse} label={t("WithNurse")} color={"#AF2591"} isSelectedCard={states.selectedCard === "With Nurse" ? true : false} /> : null}
            {this.state.totalAppointment?.with_optos > 0 && !appointmentStatus[2]?.is_checked ?
              (is_optdoc || is_selectoptdoc ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With OPTOS' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.OPTOSfill.default} count={states.totalAppointment.with_optos} label={t("With OPTOS")} color={"#fa0004"} isSelectedCard={states.selectedCard === "With OPTOS" ? true : false} /> : null) :
              appointmentStatus[2]?.is_checked ?
                (is_optdoc || is_selectoptdoc ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With OPTOS' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.OPTOSfill.default} count={states.totalAppointment.with_optos} label={t("With OPTOS")} color={"#fa0004"} isSelectedCard={states.selectedCard === "With OPTOS" ? true : false} /> : null) : null}
            {this.state.totalAppointment?.optometry > 0 && !appointmentStatus[3]?.is_checked ?
              (is_optdoc || is_selectoptdoc ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Optometry' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.OptometryFill.default} count={states.totalAppointment.optometry} label={t("With Optometry")} color={"#ffff33"} isSelectedCard={states.selectedCard === "Optometry" ? true : false} /> : null) :
              appointmentStatus[3]?.is_checked ?
                (is_optdoc || is_selectoptdoc ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Optometry' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.OptometryFill.default} count={states.totalAppointment.optometry} label={t("With Optometry")} color={"#ffff33"} isSelectedCard={states.selectedCard === "Optometry" ? true : false} /> : null) : null}
            {((this.state.totalAppointment?.optometry_completed > 0 && !appointmentStatus[4]?.is_checked) || appointmentStatus[4]?.is_checked) && (is_optdoc || is_selectoptdoc) ?
              <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Optometry Completed' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.withOptCompletedOn.default} count={states.totalAppointment?.optometry_completed || 0} label={t("Opt Completed")} color={"orange"} isSelectedCard={states.selectedCard === "Optometry Completed"} />
              : null}
            <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With Doctor' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.StatusDoctorFill.default} count={states.totalAppointment.with_doctor} label={t("WithDoctor")} color={"#29B6F6  "} isSelectedCard={states.selectedCard === "With Doctor" ? true : false} />
            {this.state.totalAppointment?.with_counsellor > 0 && !appointmentStatus[6]?.is_checked ?
              <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With Counsellor' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.withCounsellorOn.default} count={states.totalAppointment.with_counsellor ? states.totalAppointment.with_counsellor : 0} label={t("With Counsellor")} color={"#29B6F6  "} isSelectedCard={states.selectedCard === "With Counsellor" ? true : false} /> :
              appointmentStatus[6]?.is_checked ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With Counsellor' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.withCounsellorOn.default} count={states.totalAppointment.with_counsellor ? states.totalAppointment.with_counsellor : 0} label={t("With Counsellor")} color={"#29B6F6  "} isSelectedCard={states.selectedCard === "With Counsellor" ? true : false} /> : null}
            {this.state.totalAppointment?.scan_surgery > 0 && !appointmentStatus[7]?.is_checked ?
              (is_optdoc || is_selectoptdoc ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Scan/Surgery' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.ScanSurgeryFill.default} count={states.totalAppointment.scan_surgery} label={t("Scan/Surgery")} color={"#ff9900"} isSelectedCard={states.selectedCard === "Scan/Surgery" ? true : false} /> : null) :
              appointmentStatus[7]?.is_checked ?
                (is_optdoc || is_selectoptdoc ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Scan/Surgery' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.ScanSurgeryFill.default} count={states.totalAppointment.scan_surgery} label={t("Scan/Surgery")} color={"#ff9900"} isSelectedCard={states.selectedCard === "Scan/Surgery" ? true : false} /> : null) : null
            }
            <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Completed' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.CompletedPatientFill.default} count={states.totalAppointment.completed} label={t("Completed")} color={"#1E972A"} isSelectedCard={states.selectedCard === "Completed" ? true : false} />
            <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Cancelled' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.CancelPatients.default} count={states.totalAppointment.cancelled} label={t("Cancelled")} color={"#B8170D"} isSelectedCard={states.selectedCard === "Cancelled" ? true : false} />
          </div>
        </div>
      </div>
    )
  }

  AppointmentTypeIcon(type) {
    const { t } = this.props
    switch (type) {
      case "Telephonic Appointment": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("TelephonicAppointment")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Telephonic.default}></img></Tooltip></div>
      case "Mobile Appointment": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("MobileAppointment")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Phone.default}></img></Tooltip></div>
      case "Online Appointment": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("Online Appointment")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Web.default}></img></Tooltip></div>
      case "Web Appointment": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("WebAppointment")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Web.default}></img></Tooltip></div>
      case "Walk in Appointment": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("WalkAppointment")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Walkin.default}></img></Tooltip></div>
      // case "transfer": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("Transfered")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Transfer.default}></img></Tooltip><span id='eMed_OP_AptTbl_AptText' style={{ fontWeight: '600' }}>{" (Transfered)"}</span></div>
      case "transfer": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("Transferred")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Transfer.default}></img></Tooltip></div>
      default: return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={type === null ? t("Others") : type} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.DefaultAppointType.default}></img></Tooltip></div>
    }
  }

  PaymentStatus(BillAmount, ReceivedAmount) {
      return (
        <Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <PaymentsIcon sx={{ fontSize: "0.9vw", marginRight: '0.4vw', color: '#616161' }} />
            <Typography fontSize={"0.8vw"}>{`Bill : ${AmountFormat(BillAmount)} `}</Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <CheckCircleIcon sx={{ fontSize: "0.9vw", marginRight: '0.4vw', color: 'green' }} />
            <Typography color={"green"} fontSize={"0.8vw"}>{`Paid : ${AmountFormat(ReceivedAmount)} `}</Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <ReportIcon sx={{ fontSize: "0.9vw", marginRight: '0.4vw', color: "#B8170D" }} />
            <Typography color={"#B8170D"} fontSize={"0.8vw"}>{`Balance : ${AmountFormat(BillAmount - ReceivedAmount)} `}</Typography>
          </Box>
        </Box>
      )
    }

  calculateTimeDifference = (StartTime, StopTime) => {
    const start = new Date(StartTime);
    const end = new Date(StopTime);
    const difference = end.getTime() - start.getTime();
    const hours = Math.floor(difference / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);
    return <Typography fontSize={'0.8vw'} fontWeight={600} color={difference > 1200000 ? "red" : "black"}>{difference > 0 ? `${hours} Hr : ${minutes} Min : ${seconds} Sec` : "0 Hr : 0 Min: 0 Sec"}</Typography>;
  };

  renderDilationSelect = (id, index) => {
    let DilationObj = this.state.AptTblData.find((list) => (list?.appointment_id === id)) ? this.state.AptTblData.find((list) => (list?.appointment_id === id))?.dilation_details : null
    let DilationValue = DilationObj ? DilationObj[index] ? DilationObj[index]?.dilation : null : null
    let DilationValueDisable = DilationObj ? DilationObj[index] ? DilationObj[index]?.end_time : false : false
       return (
      <FormControl variant="standard" size='small' sx={{ width: '15vw', padding: 0 }}>
        <InputLabel>{'Dilation'}</InputLabel>
        <Select
          label={'Dilation'}
          value={DilationValue}
          disabled={(DilationValueDisable)}
          onChange={(e) => {
            let data = this.state.AptTblData
            if (data[this.state.AptTblData.findIndex((list) => (list?.appointment_id === id))].dilation_details) {
              data[this.state.AptTblData.findIndex((list) => (list?.appointment_id === id))].dilation_details[index].dilation = e.target.value
            } else {
              data[this.state.AptTblData.findIndex((list) => (list?.appointment_id === id))].dilation_details = [
                {
                  "dilation": e.target.value,
                  "end_time": "",
                  "start_time": ""
                }
              ]
            }
            this.setState({ AptTblData: data }, () => {
              this.UpdateDilationTime(id, false, false, index, true)
            })
          }}
          inputProps={{ style: { padding: 0, fontSize: '0.9vw' } }}
        >
          {DilationList?.map((item, index) => (
            <MenuItem key={index} value={item}>{item}</MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  }


  StatusBtns(data, id) {
    const { t } = this.props
    let FirstDilationDetails = data?.dilation_details ? data?.dilation_details[0] : {}
    let SecondDilationDetails = data?.dilation_details ? data?.dilation_details[1] : null
    let appointmentStatus = JSON.parse(localGetItem('appointment_status')) ? JSON.parse(localGetItem('appointment_status')) :
      JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status ? JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status !== null ? JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status :
        appointment_Status_opt : appointment_Status_opt
    const showDilation = !showDilationList.has(data.appointment_status);
    return (
      data.appointment_status === "Completed" ?
        <div><Button sx={{ textTransform: 'capitalize', width: "10vw", backgroundColor: Colors.themeDark }} size='small' disableElevation variant='contained'>{t("Completed")}</Button></div> :
        data?.transfer_appointment && data?.appointment_status !== 'Cancelled' ?
          <div><Button sx={{ textTransform: 'capitalize', width: "10vw", backgroundColor: Colors.themeDark }} size='small' disableElevation variant='contained'>{"Transferred"}</Button></div> :
          data.appointment_status === "Cancelled" ?
            <Tooltip title={`Cancelled Due to ${data?.cancel_reason}`} arrow placement='top'>
              <div><Button size='small' color='error' sx={{ textTransform: 'capitalize', width: '10vw' }} variant='contained'>{t("Cancelled")}</Button></div>
            </Tooltip> :
            <div>
              <ButtonGroup size="small" sx={{ backgroundColor: '#E4F2F0' }}>
                <Tooltip title={t('Arrived')} placement='top' arrow>
                  <Button id='eMed_OP_Btn' key="Arrived" onClick={() => {
                    var today = new Date()
                    var date = DateTime.fromJSDate(today).toFormat('yyyy-MM-dd')
                    var AptDate = new Date(data.appointment_date)
                    var AppointmentDate = DateTime.fromJSDate(AptDate).toFormat('yyyy-MM-dd')

                    if (date === AppointmentDate) {
                      this.postPatientStatus('Arrived', id, data.waiting_comment)
                    } else {
                      this.errorMsgFunc("Arrived status can't be changed for future or past dates.")
                    }

                  }
                  } disabled={(data.appointment_status === "Booked" || data.appointment_status === "On Queue") ? false : true}>
                    <img className='eMed_OP_AptTbl_Status_Icon' src={(data.appointment_status === 'Arrived' ||
                      data.appointment_status === "With Nurse" || data.appointment_status === 'With Counsellor' ||
                      data.appointment_status === "With Doctor" ||
                      data.appointment_status === "Optometry" || data.appointment_status === "Optometry Completed" ||
                      data.appointment_status === "Scan/Surgery") ? ImagePaths.StatusArrivedFill.default : ImagePaths.StatusArrived.default} alt='Arrived' />
                  </Button>
                </Tooltip>
                {this.state.totalAppointment?.with_nurse > 0 && !appointmentStatus[1]?.is_checked ?
                  <Tooltip title={t('WithNurse')} placement='top' arrow>
                    <Button id='eMed_OP_Btn' key="WithNurse" onClick={() => {
                      this.postPatientStatus('With Nurse', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer)
                    }
                    } disabled={(data.appointment_status === "Arrived" || data.appointment_status === "Optometry" || data.appointment_status === "With Doctor") ? false : true}>
                      <img className='eMed_OP_AptTbl_Status_Icon' src={(data.appointment_status === "With Nurse" ||
                        data.appointment_status === "With Doctor" || data.appointment_status === 'With Counsellor' ||
                        data.appointment_status === "Optometry" || data.appointment_status === "Optometry Completed" ||
                        data.appointment_status === 'Scan/Surgery') ? ImagePaths.StatusNurseFill.default : ImagePaths.StatusNurse.default} alt='With Nurse' />
                    </Button>
                  </Tooltip> :
                  appointmentStatus[1]?.is_checked ?
                    <Tooltip title={t('WithNurse')} placement='top' arrow>
                      <Button id='eMed_OP_Btn' key="WithNurse" onClick={() => {
                        this.postPatientStatus('With Nurse', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer)
                      }
                      } disabled={(data.appointment_status === "Arrived" || data.appointment_status === "Optometry" || data.appointment_status === "With Doctor") ? false : true}>
                        <img className='eMed_OP_AptTbl_Status_Icon' src={(data.appointment_status === "With Nurse" ||
                          data.appointment_status === "With Doctor" || data.appointment_status === 'With Counsellor' ||
                          data.appointment_status === "Optometry" || data.appointment_status === "Optometry Completed" ||
                          data.appointment_status === 'Scan/Surgery') ? ImagePaths.StatusNurseFill.default : ImagePaths.StatusNurse.default} alt='With Nurse' />
                      </Button>
                    </Tooltip> : null}

                {/* For Optometry Icon start */}
                {(this.state.totalAppointment?.with_optometry > 0 && !appointmentStatus[2]?.is_checked && (this.state.isOPT || this.state.isOthometry)) ?
                  <Tooltip title={t('Optometry')} placement='top' arrow>
                    <Button id='eMed_OP_Btn' key="Optometry" onClick={() => {
                      this.postPatientStatus('Optometry', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer)
                    }
                    }
                      disabled={appointmentStatus[1]?.is_checked ?
                        (((data.appointment_status === "With Nurse" || data.appointment_status === "With Doctor") ? false : true) || this.state.DisableBtn) :
                        ((data.appointment_status === "Arrived" || data.appointment_status === "With Nurse" || data.appointment_status === "With Doctor") ? false : true) || this.state.DisableBtn
                      }
                    // disabled={(data.appointment_status === "With Nurse" || data.appointment_status === "With Doctor") ? false : true}
                    >
                      <img className='eMed_OP_AptTbl_Status_Icon' src={(data.appointment_status === "Optometry" || data.appointment_status === "With Doctor" || data.appointment_status === "Scan/Surgery" || data.appointment_status === 'With Counsellor' || data.appointment_status === "Optometry Completed") ? ImagePaths.OptometryFill.default : ImagePaths.Optometry.default} alt='With Nurse' />
                    </Button>
                  </Tooltip> :
                  (appointmentStatus[2]?.is_checked && (this.state.isOPT || this.state.isOthometry)) ?
                    <Tooltip title={t('Optometry')} placement='top' arrow>
                      <Button id='eMed_OP_Btn' key="Optometry" onClick={() => {
                        this.postPatientStatus('Optometry', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer)
                      }
                      }
                        disabled={appointmentStatus[1]?.is_checked ?
                          (((data.appointment_status === "With Nurse" || data.appointment_status === "With Doctor") ? false : true) || this.state.DisableBtn) :
                          ((data.appointment_status === "Arrived" || data.appointment_status === "With Nurse" || data.appointment_status === "With Doctor") ? false : true) || this.state.DisableBtn
                        }
                      // disabled={(data.appointment_status === "With Nurse" || data.appointment_status === "With Doctor") ? false : true}
                      >
                        <img className='eMed_OP_AptTbl_Status_Icon' src={(data.appointment_status === "Optometry" || data.appointment_status === "With Doctor" || data.appointment_status === "Scan/Surgery" || data.appointment_status === 'With Counsellor' || data.appointment_status === "Optometry Completed") ? ImagePaths.OptometryFill.default : ImagePaths.Optometry.default} alt='With Nurse' />
                      </Button>
                    </Tooltip> : null}
                {/* For Optometry Icon end */}
                {/* For Optometry completed start */}
                {((this.state.totalAppointment?.optometry_completed > 0 && !appointmentStatus[3]?.is_checked) || (appointmentStatus[3]?.is_checked)) && (this.state.isOPT || this.state.isOthometry) ?
                  <Tooltip title={t('Optometry Completed')} placement='top' arrow>
                    <Button id='eMed_OP_Btn' key="Optometry Completed" onClick={() => {
                      this.postPatientStatus('Optometry Completed', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer)
                    }}
                      disabled={(((data.appointment_status === "Optometry") ? false : true) || this.state.DisableBtn)}
                    >
                      <img className='eMed_OP_AptTbl_StatusCom_Icon' src={(data.appointment_status === "Optometry Completed" || data.appointment_status === "With Doctor" || data.appointment_status === "Scan/Surgery" || data.appointment_status === 'With Counsellor') ? ImagePaths.withOptCompletedOn.default : ImagePaths.withOptCompletedOff.default} alt='Opt Complete' />
                    </Button>
                  </Tooltip> : null}
                {/* For Optometry completed end */}
                <Tooltip title={t('WithDoctor')} placement='top' arrow>
                  <Button id='eMed_OP_Btn' key="WithDoctor" onClick={() => {
                    this.postPatientStatus('With Doctor', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer)
                  }
                  }
                    disabled={this.state.totalAppointment?.with_nurse > 0 && !appointmentStatus[1]?.is_checked ?
                      ((data.appointment_status === "With Nurse" || data.appointment_status === 'Optometry' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' || data.appointment_status === "Optometry Completed" ? false : true) || this.state.DisableBtn) :
                      appointmentStatus[1]?.is_checked ?
                        ((data.appointment_status === "With Nurse" || data.appointment_status === 'Optometry' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' || data.appointment_status === "Optometry Completed" ? false : true) || this.state.DisableBtn) :
                        ((data.appointment_status === "Arrived" || data.appointment_status === "With Nurse" || data.appointment_status === 'Optometry' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' || data.appointment_status === "Optometry Completed" ? false : true) || this.state.DisableBtn)
                    }
                  //  disabled={data.appointment_status === "With Nurse" || data.appointment_status === 'Optometry' || data.appointment_status === 'Scan/Surgery' ? false : true}
                  >
                    <img className='eMed_OP_AptTbl_Status_Icon' src={data.appointment_status === "With Doctor" || data.appointment_status === 'With Counsellor' || data.appointment_status === "Scan/Surgery" ? ImagePaths.StatusDoctorFill.default : ImagePaths.StatusDoctor.default} alt='With Doctor' />
                  </Button>
                </Tooltip>
                {this.state.totalAppointment?.with_counsellor > 0 && !appointmentStatus[5]?.is_checked ?
                  <Tooltip title={t('With Counsellor')} placement='top' arrow>
                    <Button id='eMed_OP_Btn' key="WithCounsellor" onClick={() => {
                      this.postPatientStatus('With Counsellor', id, data.waiting_comment)
                    }}
                      disabled={((data.appointment_status === "With Doctor" || data.appointment_status === 'Scan/Surgery' ? false : true) || this.state.DisableBtn)}
                    // disabled={(data.appointment_status === "With Doctor" ? false : true) || this.state.DisableBtn}
                    >
                      <img className='eMed_OP_AptTbl_Status_Icon' src={data.appointment_status === "With Counsellor" || data.appointment_status === "Scan/Surgery" ? ImagePaths.withCounsellorOn.default : ImagePaths.withCounsellorOff.default} alt='With Counsellor' />
                    </Button>
                  </Tooltip> :
                  appointmentStatus[5]?.is_checked ?
                    <Tooltip title={t('With Counsellor')} placement='top' arrow>
                      <Button id='eMed_OP_Btn' key="WithCounsellor" onClick={() => {
                        this.postPatientStatus('With Counsellor', id, data.waiting_comment)
                      }
                      }
                        disabled={((data.appointment_status === "With Doctor" || data.appointment_status === 'Scan/Surgery' ? false : true) || this.state.DisableBtn)}
                      // disabled={(data.appointment_status === "With Doctor" ? false : true) || this.state.DisableBtn}
                      >
                        <img className='eMed_OP_AptTbl_Status_Icon' src={data.appointment_status === "With Counsellor" || data.appointment_status === "Scan/Surgery" ? ImagePaths.withCounsellorOn.default : ImagePaths.withCounsellorOff.default} alt='With Counsellor' />
                      </Button>
                    </Tooltip> : null}
                {/* For Optometry Icon start */}
                {this.state.totalAppointment?.scan > 0 && !appointmentStatus[6]?.is_checked && (this.state.isOPT || this.state.isOthometry) ?
                  <Tooltip title={t('Scan/Surgery')} placement='top' arrow>
                    <Button id='eMed_OP_Btn' key="Scan/Surgery" onClick={() => {
                      this.postPatientStatus('Scan/Surgery', id, data.waiting_comment)
                    }
                    } disabled={(data.appointment_status === "With Doctor" || data.appointment_status === 'With Counsellor') ? false : true}>
                      <img className='eMed_OP_AptTbl_Status_Icon' src={(data.appointment_status === "Scan/Surgery") ? ImagePaths.ScanSurgeryFill.default : ImagePaths.ScanSurgery.default} alt='With Nurse' />
                    </Button>
                  </Tooltip> :
                  (appointmentStatus[6]?.is_checked && (this.state.isOPT || this.state.isOthometry)) ?
                    <Tooltip title={t('Scan/Surgery')} placement='top' arrow>
                      <Button id='eMed_OP_Btn' key="Scan/Surgery" onClick={() => {
                        this.postPatientStatus('Scan/Surgery', id, data.waiting_comment)
                      }
                      } disabled={(data.appointment_status === "With Doctor" || data.appointment_status === 'With Counsellor') ? false : true}>
                        <img className='eMed_OP_AptTbl_Status_Icon' src={(data.appointment_status === "Scan/Surgery") ? ImagePaths.ScanSurgeryFill.default : ImagePaths.ScanSurgery.default} alt='With Nurse' />
                      </Button>
                    </Tooltip> : null}
                {/* For Optometry Icon end */}
                <Tooltip title={t('Completed')} placement='top' arrow>
                  <Button id='eMed_OP_Btn' key="Completed" onClick={() => {
                    this.postPatientStatus('Completed', id, data.waiting_comment)
                  }
                  } disabled={data.appointment_status === 'With Doctor' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' ? false : true} >
                    <img className='eMed_OP_AptTbl_StatusCom_Icon' src={ImagePaths.StatusCompleted.default} alt='Completed' />
                  </Button>
                </Tooltip>
              </ButtonGroup>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Box display={(((this.state.isOthometry) || (this.state.isOPT)) && FirstDilationDetails && showDilation) ? "flex" : "none"} sx={{ flexDirection: 'column', alignItems: "center", justifyContent: "space-between", height: "7vh", marginTop: '0.5vw' }}>
                  {this.renderDilationSelect(id, 0)}
                  <Box sx={{ display: 'flex', justifyContent: "space-around", alignItems: 'center' }}>
                    {FirstDilationDetails && FirstDilationDetails?.start_time && !FirstDilationDetails?.end_time ? this.calculateTimeDifference(FirstDilationDetails?.start_time, this.state.currentTime) : (FirstDilationDetails?.start_time && FirstDilationDetails?.end_time ? this.calculateTimeDifference(FirstDilationDetails?.start_time, FirstDilationDetails?.end_time) : <Typography fontSize={'0.8vw'} fontWeight={600}>{"0 Hr : 0 Min: 0 Sec"}</Typography>)}
                    {!FirstDilationDetails?.start_time ? <Button   size='small' sx={{ textTransform: "capitalize", fontWeight: 600 }} onClick={() => { this.UpdateDilationTime(id, true, false, 0) }}>Start</Button> : null}
                    {FirstDilationDetails?.start_time && !FirstDilationDetails?.end_time ? <Button   sx={{ textTransform: "capitalize", fontWeight: 600 }} size='small' color='error' onClick={() => { this.UpdateDilationTime(id, false, true, 0) }}>Stop</Button> : null}
                    {FirstDilationDetails?.end_time && !SecondDilationDetails ? <Button sx={{ textTransform: "capitalize", fontWeight: 600 }} size='small' color='info' onClick={() => {
                      let data = this.state.AptTblData
                      data[this.state.AptTblData.findIndex((list) => (list?.appointment_id === id))].dilation_details[1] = {
                        "dilation": "",
                        "end_time": "",
                        "start_time": ""
                      }
                      this.setState({ AptTblData: data })
                    }}>Add New</Button> : null}
                  </Box>
                </Box>
                <Box display={(((this.state.isOPT) || (this.state.isOthometry)) && SecondDilationDetails && showDilation) ? "flex" : "none"} sx={{ flexDirection: 'column', alignItems: "center", justifyContent: "space-between", height: "7vh", marginTop: "0.5vw" }}>
                  {this.renderDilationSelect(id, 1)}
                  <Box sx={{ display: 'flex', justifyContent: "space-around", alignItems: 'center' }}>
                    {SecondDilationDetails && SecondDilationDetails?.start_time && !SecondDilationDetails.end_time ? this.calculateTimeDifference(SecondDilationDetails?.start_time, this.state.currentTime) : (SecondDilationDetails?.start_time && SecondDilationDetails.end_time ? this.calculateTimeDifference(SecondDilationDetails?.start_time, SecondDilationDetails.end_time) : <Typography fontSize={'0.8vw'} fontWeight={600}>{"0 Hr : 0 Min: 0 Sec"}</Typography>)}
                    {!SecondDilationDetails?.start_time ? <Button   sx={{ textTransform: "capitalize", fontWeight: 600 }} size='small' onClick={() => { this.UpdateDilationTime(id, true, false, 1) }}>Start</Button> : null}
                    {SecondDilationDetails?.start_time && !SecondDilationDetails.end_time ? <Button   sx={{ textTransform: "capitalize", fontWeight: 600 }} size='small' color='error' onClick={() => { this.UpdateDilationTime(id, false, true, 1) }}>Stop</Button> : null}
                  </Box>
                </Box>
              </Box>
            </div>

    )
  }

  DocPatientCall = (appDetail) => {
    try {
      let data = {
        appointment_id: appDetail?.appointment_id ? appDetail?.appointment_id : null
      }
      RestAPIService.create(data, Serviceurls.DOC_CALL_PATIENT)
        .then((response) => {
          if (response?.data?.status === 'success') {
            let id = response?.data?.data?.id ? response?.data?.data?.id : null
            this.successMsgFunc(response.data.message)
            if (this.DocCallPatient) {
              this.DocCallPatient.send(JSON.stringify({ id: id }))
            }
            if (this.TokenScreen) {
              this.TokenScreen.send(JSON.stringify({ id: id }))
            }
            this.getPatientDetails()
            this.setState({ disableBtn: false })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMsgFunc(error.response.data.message)
            if (error.response.data.message?.includes("Patient already assigned")) {
              this.getPatientDetails()
            }
          } else {
            this.errorMsgFunc(error.message)
          }
          this.setState({ disableBtn: false })
        })
    } catch (error) {
      this.setState({ disableBtn: false })
      this.errorMsgFunc(error.message)
    }
  }

  onEmergency = () => {
    try {
      let clinicId = JSON.parse(localGetItem("SelectedDoctorClinicId"))
      let data = {
        out_for_emergency: this.state.isDocOnEmergency,
        clinic_id: clinicId ? clinicId : null
      }
      RestAPIService.create(data, Serviceurls.DOC_WENT_FOR_EMERGENCY)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.successMsgFunc(response.data.message)
            if (this.EmergencySocket) {
              this.EmergencySocket.send(JSON.stringify({ id: response?.data?.data?.id ? response?.data?.data?.id : null }))
            }
            this.setState({ disableBtn: false })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMsgFunc(error.response.data.message)
          } else {
            this.errorMsgFunc(error.message)
          }
          this.setState({ disableBtn: false })
        })
    } catch (error) {
      this.setState({ disableBtn: false })
      this.errorMsgFunc(error.message)
    }
  }

  ActionBtn = (data) => {
    const { t } = this.props
    var states = this.state
    let enable_billing = localGetItem('enable_billing') === 'true' ? true : false
    let enable_bill_trans = localGetItem('enable_billing_transaction') === 'true' ? true : false
    let multi_option = [
      // { label: "NextAppointment", value: "NextAppointment" },
      { label: "PrintDoctorNotes", value: "PrintDoctorNotes" },
      { label: "PrintPrescription", value: "PrintPrescription" },
      { label: "OpBarcode", value: "OpBarcode" },
      { label: "PresTem", value: "PrescriptionTemplate" },
      { label: "BarCode", value: "CommonBarcode" },
      { label: "MedicalRecord", value: "MedicalRecord" },
      { label: "Patient Remarks", value: "PatientRemarks" },
    ]
    let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
    if (data?.row?.is_emergency) {
      multi_option?.push({ label: 'Disable Highlight', value: 'ChangeTag' })
    }
    let isTodayDate = DateTime.fromJSDate(new Date(this.state?.datePicker)).toFormat('yyyy-MM-dd') === DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd')
    return (
      <div className='eMed_OP_Apt_ActionBtn' style={{ width: '6vw' }}>
        <div>
          <Tooltip title={t("More")} placement='top' arrow>
            <IconButton
              onClick={(e) => {
                this.setState({
                  anchorEl: e.currentTarget,
                  selectedRow: data.id,
                  isSelected: true,
                  remarkText: data?.comments
                })
              }}
              disabled={(data.row.appointment_status === "Cancelled" || data.row.appointment_status === "No Show" || data.row.transfer_appointment) ? true : false}
            >
              <img src={ImagePaths.StoreViewButton.default} style={{width: '1.5vw', height: '1.5vw'}} alt='list'/>
            </IconButton>
          </Tooltip>
          {(this.state.isSelected && this.state.selectedRow == data.id) ?
            <Menu
              anchorEl={this.state.anchorEl}
              open={Boolean(this.state.anchorEl)}
              onClose={() => {
                this.setState({ anchorEl: null, })
              }}
            >
              {multi_option.map((option, i) => (
                <MenuItem key={i}
                  disabled={(this.state.slctMenuOption === option.value) ||
                    (((data.row.appointment_status !== "Completed" && data.row.appointment_status !== "With Doctor") ||
                      data.row.is_nurse) && (option.label === "PrintDoctorNotes" || option.label === "PrintPrescription")) ||
                    (data.row.is_nurse && option.label === "PresTem") ||
                    (option.label === "TransAppoint" && data.row.appointment_status === "Completed")
                    ? true : false}
                  onClick={() => {
                    this.setState({
                      selectedOption: option.value, anchorEl: null,
                      SelectedPatientDetails: data.row, tokenNum: data.row.token_number,
                      slctMenuOption: option.value,
                    })
                  }}>
                  {t(option.label)}
                </MenuItem>
              ))}
            </Menu> : null}
        </div>
      </div>
    )
  }

  routeToDemograhics = (params, MoveToDocu = false) => {
    let { history } = this.props;
    if (params?.row?.doctor_id) {
      if (MoveToDocu) {
        setCachevalue(JSON.stringify(params?.row), "DoctorPatientData")
        setCachevalue(JSON.stringify(params?.row), "WaitingPatientData")
        setCachevalue(JSON.stringify(params?.row?.timer), "waitingTime")
        setCachevalue(JSON.stringify(this.state.datePicker), 'SelectedDate')
        history.push({ pathname: "/DoctorHome/PatientDocuments" })
        setCachevalue(true, 'updatePatient')
      } else {
        if (params.field === "patientDetails" || (params.field === "purpose_of_visit" && !this.state.onChangePov) || params.field === "appointment_start_time" || params.field === "bill_amount" || (params.field === "token_number" && !this.state.onAddComment)) {
          setCachevalue(JSON.stringify(params?.row), "DoctorPatientData")
          setCachevalue(JSON.stringify(params?.row), "WaitingPatientData")
          setCachevalue(JSON.stringify(params?.row?.timer), "waitingTime")
          setCachevalue(JSON.stringify(this.state.datePicker), 'SelectedDate')
          history.push({ pathname: "/DoctorHome/DoctorNotes" })
          setCachevalue(true, 'updatePatient')
        }
      }
    } else {
      if (params.field === "patientDetails" || (params.field === "purpose_of_visit" && !this.state.onChangePov) || params.field === "appointment_start_time" || params.field === "bill_amount" || (params.field === "token_number" && !this.state.onAddComment)) {
        this.errorMsgFunc("The patient is not assigned to any doctor. Click the Call button to assign.")
      }
    }
  }
  handleClose = () => {
    this.setState({
      waitingCmts: false
    })
  }

  

  povPopClose = () => {
    this.setState({
      povText: {},
      ispovPopOpen: false,
      onChangePov: false,
    })
  }

  
  waitTime = (data, id) => {
    var { AptTblData } = this.state;

    const convertTime12to24 = moment(data.patient_arrived_time, ["h:mm A"]).format("HH:mm");
    var year = moment(new Date(data.appointment_date)).format("LL") + " " + convertTime12to24 + ":00"
    var currnet_date = new Date();
    var arrived_date = new Date(year);
    var res = Math.abs(currnet_date - arrived_date) / 1000;
    var days = Math.floor(res / 86400);
    var hours = Math.floor(res / 3600) % 24;
    var minutes = Math.floor(res / 60) % 60;
    var seconds = res % 60;

    var result = hours + ' Hr ' + minutes + ' Mins.'
    var time = data.patient_arrived_time ? "Arrived: " + data.patient_arrived_time + " | " + (data.waiting_timer ? data.waiting_timer : result) : "-"

    AptTblData && AptTblData.length > 0 && (AptTblData).map((element, index) => {
      if (id === element.patient_id && element.timer != result && element.timer === undefined) {
        AptTblData[index]["timer"] = result === "NaN Hr NaN Mins." ? "0 Hr 0 Mins." : result
        this.setState({
          AptTblData
        })
      }
    })
    const isRedColor = data?.waiting_timer ? data?.waiting_timer?.split(" ")[0] : data?.timer?.split(" ")[0]
    const waitingTimer = result === "NaN Hr NaN Mins." ? "0 Hr 0 Mins." : result;
    // const isRedColor = this.parseWaitingTimer(waitingTimer) > 60; // Check if waiting time is greater than 1 hour

    return (
      // <Typography id='eMed_OP_AptTbl_AptText1'>{time}</Typography>
      <div id='eMed_OP_AptTbl_AptText1' style={{ marginTop: "0.2vw", fontWeight: 'bold' }}>
        {`${time.split("|")[0]} | `}<span id='eMed_OP_AptTbl_AptText1' style={{ color: isRedColor >= 1 ? 'red' : 'black' }}>{time.split("|")[1]}</span>
      </div>
    )
  }

  parseWaitingTimer(timer) {
    const [hours, mins] = timer.match(/\d+/g).map(Number);
    return hours * 60 + mins;
  }

  numberSort = (v1, v2) => {
    let sorted = gridNumberComparator(v1, v2);
    return sorted;
  }
  renderAptTable = () => {
    const { t } = this.props
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    const loggedInUserInfo = myUser?.appointment_status;
    const appointmentStatus = (loggedInUserInfo !== null ? loggedInUserInfo : appointment_Status_opt);
    const columns = [
      {
        field: 'patientDetails', headerName: t('Patient Details'), headerClassName: 'eMed_Apt_TblHead', flex: 0.170,
        renderCell: (params) => (
          <NewCommonPatientDetails data={params.row} showTag={true} fromOp={true} />
        ), density: 'compact'
      },
      {
        field: 'token_number', headerName: t('AppointmentDetails'), headerClassName: 'eMed_Apt_TblHead', flex: 0.140, density: 'compact',
        renderCell: (params) => {
          let priorityLvl = params?.row?.appointment_type_priority ? params?.row?.appointment_type_priority : ''
          let bgColor = priorityLvl === "Priority_Level_1" ? "#1E972A" : priorityLvl === "Priority_Level_2" ? "#0461B7" : priorityLvl === "Priority_Level_3" ? "#DE7D24" : ''
          return (
            <div>
              <div className='eMed_OP_PatientType' style={{alignItems:'center'}}> <Typography id='eMed_OP_AptTbl_AptText' sx={{ fontWeight: '600', color: bgColor ? 'white' : 'black', backgroundColor: bgColor, padding: bgColor ? '0.2vw' : '0', borderRadius: bgColor ? '0.4vw' : '0' }}>{'Token :' + (params.row.token_number ? params.row.token_number : '-')}</Typography>
                {/* <div>{this.AppointmentTypeIcon(params.row.is_transfered ? "transfer" : params.row.patient_appointment_types)}</div> */}
                <div>{this.AppointmentTypeIcon(params.row.patient_appointment_types)}</div>
                {params.row.is_transfered ? <div>{this.AppointmentTypeIcon(params.row.is_transfered ? "transfer" : null)}</div> : null}
                <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={params.row.patient_documents ? "Documents Uploaded" : "Document Not Uploaded"} arrow>
                  <img className='eMed_OP_Patient_Iconcircle' src={params.row.patient_documents ? ImagePaths.isDocUploaded.default : ImagePaths.isDocNotUploaded.default} onMouseOver={() => { this.setState({ onAddComment: true }) }} onMouseLeave={() => { this.setState({ onAddComment: false }) }}
                    onClick={() => {
                      if (params.row.appointment_status === "Cancelled" || params.row.appointment_status === "No Show" || !params.row.patient_documents) {

                      } else {
                        this.routeToDemograhics(params, true)
                      }
                    }}>
                  </img></Tooltip></div></div>
              <div className='eMed_OP_AptTbl_Comment'>
                {(params.row?.waiting_comment?.length > 0 && params.row?.waiting_comment[params.row?.waiting_comment?.length - 1]?.comments) ? (params.row?.waiting_comment[params.row?.waiting_comment?.length - 1]?.comments)?.length > 12 ?
                  <Tooltip title={params.row?.waiting_comment[params.row?.waiting_comment?.length - 1]?.comments} placement='top' arrow>
                    <div><Typography id='eMed_OP_AptTbl_AptText'>{`WC.:${params.row?.waiting_comment[params.row?.waiting_comment?.length - 1]?.comments.slice(0, 12) + '...'}`}</Typography></div>
                  </Tooltip> : <Typography id='eMed_OP_AptTbl_AptText'>{`WC.:${params.row?.waiting_comment[params.row?.waiting_comment?.length - 1]?.comments}`}</Typography> : <Typography id='eMed_OP_AptTbl_AptText'>{"WC.:-"}</Typography>
                }
              </div>
              <div>{params.row.doctor_name?.length > 12 ?
                <Tooltip title={params.row.doctor_name} placement={'top'} arrow>
                  <Typography id='eMed_OP_AptTbl_AptText'>{'Consultant :' + (params.row.doctor_name ? params.row.doctor_name.slice(0, 12) + '...' : '-')}</Typography>
                </Tooltip> : <Typography id='eMed_OP_AptTbl_AptText'>{'Consultant :' + (params.row.doctor_name ? params.row.doctor_name : '-')}</Typography>} </div>

            </div>)
        }, valueGetter: (params) => params.row.token_number, sortComparator: this.numberSort, sortingOrder: ['asc', 'desc']
      },
      {
        field: 'appointment_start_time', headerName: t('Arriving/WaitingTime'), headerClassName: 'eMed_Apt_TblHead', flex: 0.136, density: 'compact',
        renderCell: (params) => (
          <div>
            {this.waitTime(params.row, params.row.patient_id)}
            <Typography id='eMed_OP_AptTbl_AptText1' >{`Booked: ${params.row.appointment_start_time}`}</Typography>
          </div>
        )
      },
      {
        field: 'bill_amount', headerName: t('PaymentStatus'), headerClassName: 'eMed_Apt_TblHead', flex: 0.125, density: 'compact',
        renderCell: (params) => (
          <div>{this.PaymentStatus(params.row?.bill_amount || 0, params.row?.received_amount || 0)}</div>)
      },
      {
        field: 'purpose_of_visit', headerName: 'Purpose of Visit', headerClassName: 'eMed_Apt_TblHead', flex: 0.124, density: 'compact',
        renderCell: (params) => (
          <Box width={"100%"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
            {params.row.purpose_of_visit?.length > 14 ?
              <Tooltip title={params.row.purpose_of_visit} placement={'top'} arrow>
                <Typography id=''>{(params.row.purpose_of_visit ? params.row.purpose_of_visit.slice(0, 12) + '...' : '-')}</Typography>
              </Tooltip> : <Typography id=''>{(params.row.purpose_of_visit ? params.row.purpose_of_visit : '-')}</Typography>}
            {(params.row.appointment_status !== "Cancelled" && params.row.appointment_status !== "Completed") ?
              <Tooltip title={'Edit'} placement='top' arrow>
                <div emed_tid={"fo_pov_edit"} size="small"
                  onClick={() => this.setState({
                    povText: params.row,
                    ispovPopOpen: true,
                  })}
                  onMouseOver={() => { this.setState({ onChangePov: true }) }}
                  onMouseLeave={() => { this.setState({ onChangePov: false }) }}>
                  <img src={ImagePaths.UserEditOn.default} className='eMed_list_image' alt='edit' />
                </div>
              </Tooltip> : null}
          </Box>)
      },
      {
        field: 'action', headerName: t('Action'), headerClassName: 'eMed_Apt_TblHead', flex: 0.09, headerAlign: 'center', density: 'compact', sortable: false, hideable: false, align: 'center',
        renderCell: (params) => (
          <div>{this.ActionBtn(params)}</div>
        )
      }
    ]
    this.state.AptTblData.forEach((element, index) => { element.sno = index + 1 })
    return (
      <div>
        <Box className='eMed_AptTbl_Con'>
          <DataGrid
            rows={this.state.AptTblData}
            columns={columns}
            getRowId={(row) => row['sno']}
            pageSize={this.state.pageSize}
            page={this.state.page}
            rowsPerPageOptions={[10, 20, 30]}
            components={{
              Toolbar: this.gridToolBar,
              NoRowsOverlay: () => (
                <Stack className='eMed_conf_nodata'>
                  {t("NoRecordsFound")}
                </Stack>
              )
            }}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            density={'compact'}
            getRowHeight={(params) => {
              if (((this.state.isOthometry) || (this.state.isOPT)) && !showDilationList.has(params?.model?.appointment_status) && params?.model?.transfer_appointment === false) {
                if (params?.model?.dilation_details && params?.model?.dilation_details?.length > 1) {
                  return 185
                } else {
                  return 140
                }
              } else {
                return 80
              }
            }}
            onCellClick={(params) => (params.row.appointment_status === "Cancelled" || params.row.appointment_status === "No Show") ? null : this.routeToDemograhics(params)}
            pagination
            onPageChange={(newPage) => { this.setState({ page: newPage }) }}
            onPageSizeChange={(newPageSize) => { this.setState({ pageSize: newPageSize }) }}
            getRowClassName={(params) => {
              if (params.row.appointment_status === "Cancelled" || params.row.appointment_status === "No Show") {
                return 'eMed_OP_CancelPatient'
              } else {
                return null
              }
            }}
            disableSelectionOnClick
            loading={this.state.loading}
          />
        </Box>
      </div>
    )
  }
  NxtAppiontmentClose() {
    setTimeout(() => { this.setState({ selectedOption: "" }) }, 1000)
  }
  NxtAppointmentSuccess(message) {
    this.setState({ selectedOption: "" }, () => {
      this.successMsgFunc(message)
      this.getPatientDetails()
    })
  }
  renderNxtApointmtPopup = () => {
    const { selectedOption, SelectedDoctorClinic, SelectedPatientDetails } = this.state;
    const commonProps = {
      PostSuccess: this.NxtAppointmentSuccess.bind(this),
      NxtAppiontmentClose: this.NxtAppiontmentClose.bind(this),
      PatientDetails: SelectedPatientDetails,
    };

    switch (selectedOption) {
      case "NextAppointment":
        return <NextAppointments {...commonProps} FromDoctor={true} clinic_id={SelectedDoctorClinic} ScreenName={"NextAppointment"} />;
      case "Reschedule":
        return <NextAppointments {...commonProps} ScreenName={"RescheduleAppiontment"} />;
      case "TransAppoint":
        return <NextAppointments {...commonProps} FromDocTrans={true} clinic_id={SelectedDoctorClinic} ScreenName={"TransAppoint"} AppointmentType={true} />;
      case "PrintDoctorNotes":
        this.getPatientDoctorNotesPrint();
        break;
      case "PrintPrescription":
        this.getPatientPrescriptionPrint();
        break;
      case "OpBarcode":
        this.getPatientOpCardPrint(false);
        break;
      case "OpCard":
        this.getPatientOpCardPrint(true);
        break;
      case "BillDetails":
        this.getPatientOpBillDetailPrint();
        break;
      case "PrescriptionTemplate":
        this.getPatientPresTemplate();
        break;
      case "CommonBarcode":
        this.getCommonBarCodePrint();
        break;
      case "MedicalRecord":
        this.getMedicalRecordPrint();
        break;
      case "ChangeTag":
        this.postChangeTagNormal();
        break;
      case "PatientRemarks":
        this.setState({ isRemarks: true, selectedOption: "", slctMenuOption: "", remarkText: SelectedPatientDetails?.comments || '' });
        break;
      case "CancelAppontment":
        this.setState({ cancelAppointment: true, selectedOption: "" })
      default:
        return null;
    }
    this.setState({ selectedOption: "", slctMenuOption: "" });
  }

  renderPatientRemarks = () => {
    const { t } = this.props
    var states = this.state
    return (
      <Dialog
        open={this.state.isRemarks}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="eMed_DialogBox_Title" style={{ padding: '0.5vw' }}>
          <div>
            {t("Patient Remarks")}
          </div>
          <div className="eMed_DialogBox_Close">
            <img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt='Close' onClick={() => { this.setState({ isRemarks: false, remarkText: '' }) }} />
          </div>
        </div>
        <div>
          <DialogContent>
            <TextField
              sx={{ width: '25vw' }}
              multiline
              inputProps={{ maxLength: 1000 }}
              rows={3}
              placeholder={t("Add Remarks")}
              variant="outlined"
              value={this.state.remarkText}
              onChange={(e) => {
                this.setState({ remarkText: e.target.value })
              }} />
          </DialogContent>
          <DialogActions id="eMed_DialogBox_Btn">
            <Button size="small" variant='outlined' id="eMed_Dia_Btn" onClick={() => { this.setState({ remarkText: '' }) }}>
              {t('Clear')}
            </Button>
            <Button size="small" variant='contained' id="eMed_Dia_Btn" onClick={() => { this.postInternalCmt() }}>
              {t('Add')}
            </Button>

          </DialogActions>
        </div>
      </Dialog>
    )
  }

  postInternalCmt = () => {
    try {
      let data = {
        "comments": this.state.remarkText,
        "appointment_id": this.state.SelectedPatientDetails?.appointment_id,
        "patient_id": this.state.SelectedPatientDetails?.patient_id
      }
      RestAPIService.create(data, Serviceurls.FO_INTERNAL_CMT)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.successMsgFunc(response?.data?.message)
            this.setState({
              isRemarks: false,
            })
            this.getPatientDetails()
          }
        })
        .catch((e) => {
          if (e.response.data.status === 'fail') {
            this.errorMsgFunc(e.response.data.message)
          } else {
            this.errorMsgFunc(e.message)
          }
        })
    } catch (e) {
      this.errorMsgFunc(e.message)
    }
  }

  postChangeTagNormal = () => {
    try {
      let data = {
        appointment_id: this.state.SelectedPatientDetails?.appointment_id,
        is_emergency: false
      }
      RestAPIService.create(data, Serviceurls.FO_IP_OP_PATIENT_TAG_CHANGE_NORMAL)
        .then((response) => {
          if (response?.data?.status === 'Success') {
            this.successMsgFunc(response.data.message)
            this.getPatientDetails()
            this.setState({ selectedOption: "", slctMenuOption: "" })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ selectedOption: "", slctMenuOption: "" })
            this.errorMsgFunc(error.response.data.message)
          } else {
            this.errorMsgFunc(error.message)
            this.setState({ selectedOption: "", slctMenuOption: "" })
          }
        })
    } catch (error) {
      this.setState({ selectedOption: "", slctMenuOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  popupClose = () => {
    this.setState({
      waitingCmts: false,
      cancelAppointment: false
    })
  }
  addCancelComments = (comments) => {
    var states = this.state
    this.postPatientStatus('Cancelled', states.SelectedPatientDetails.appointment_id, comments, states.SelectedPatientDetails.timer, states.SelectedPatientDetails?.waiting_timer, false, states.SelectedPatientDetails)
    this.setState({
      cancelAppointment: false
    })
  }

  gridToolBar = () => {
    var { t } = this.props
    var StateDate = new Date(this.state.datePicker)
    var date = this.state.datePicker ? DateTime.fromJSDate(StateDate).toFormat('yyyy-MM-dd') : null
    let TextArray = [
      { label: "From Date", value: formatDate(date) },
      { label: "To Date", value: formatDate(date) },
    ]
    let ExportData = [];
    this.state.AptTblData?.length > 0 && this.state.AptTblData?.map((item) =>
      ExportData.push(
        {
          "Patient Name": item.patient_name ? item.patient_name : '-',
          "Age": item.patient_age ? item.patient_age : '-',
          "Gender": item.patient_gender ? item.patient_gender : '-',
          "Mobile Number": item.patient_mobile_number ? item.patient_mobile_number : '-',
          "UHID": item.patient_account_number ? item.patient_account_number : '-',
          "Appointment Date": item.appointment_date ? DateTime.fromJSDate(new Date(item.appointment_date)).toFormat('dd-MM-yyyy') : '-',
          "Appointment Time": item.appointment_start_time ? item.appointment_start_time : '-',
          "Appointment Type": item.patient_appointment_types ? item.patient_appointment_types : '-',
          "Token Number": item.token_number ? item.token_number : '-',
          "Bill Amount": item.bill_amount ? item.bill_amount : '-',
          "Received Amount": item.received_amount ? item.received_amount : '-',
          "Purpose of Visit": item.purpose_of_visit ? `"${item.purpose_of_visit}"` : '-',
        })
    )
    return (
      <Box>
        <CommonGridToolBarWithFilterTextCustom
          FilterTextArray={TextArray}
          data={ExportData}
          title={"Patient List"}
          filename={"PatientList"} />
      </Box>
    )
  }
  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }
  render() {
    return (
      <div className='eMed_OP_Appointment'>
        {this.renderOPHeader()}
        {this.renderPatientType()}
        {this.renderAptTable()}
        {this.state.selectedOption != "" ? this.renderNxtApointmtPopup() : null}
        {this.state.isRemarks ? this.renderPatientRemarks() : null}
        {this.state.cancelAppointment ? <ReasonPopup
          title={"Are you sure? Do you want to cancel the appointment"}
          AlertPopupClose={this.popupClose.bind(this)}
          label={"Enter the Reason"}
          btntext={'Cancel'}
          btnvarient={'outlined'}
          btncolor={'error'}
          btntext1={'Confirm'}
          btnvarient1={'contained'}
          sendCmt={this.addCancelComments.bind(this)} /> : null}
          {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.ispovPopOpen ?
          <PovEditPopup
            povEditText={this.state.povText.purpose_of_visit}
            povData={this.state.povText}
            getTableData={this.getPatientDetails.bind(this)}
            AlertPopupClose={this.povPopClose.bind(this)}
            successMsg={this.successMsgFunc.bind(this)}
            errorMsg={this.errorMsgFunc.bind(this)}
          /> : null}

        <Drawer
          anchor={'right'}
          open={this.state.FilterOpen}
          ModalProps={{ onBackdropClick: this.closeFilter }}
        >
          {this.renderFilterScreen()}
        </Drawer>
      </div>

    )
  }
}

export default withTranslation()(JmoDoctorHome);